import { RecipeTagWrapper } from '@core';

export class ChronodriveRecipeTagWrapper extends RecipeTagWrapper {
  constructor(recipeDetailPreviewAllowed = true) {
    super(recipeDetailPreviewAllowed)
  }

  tagPlaceholders() {
    const items = document.getElementsByClassName('item');
    [...items].forEach(item => {
      if (item.getElementsByClassName('miam-recipe-tag-container').length == 0) { // Don't insert a tag if there is one already
        const tagContainer = document.createRange().createContextualFragment(
          `<div class="miam-recipe-tag-container"><div class="miam-recipe-tag-placeholder"></div></div>`
        );
        item.appendChild(tagContainer);
        item.getElementsByClassName('item-actions')[0].style = "bottom: auto; top: 34px;";
      }
    })
    return document.getElementsByClassName('miam-recipe-tag-placeholder')
  }

  itemExtId(recipeTagElement) {
    return recipeTagElement.parentElement.parentElement.getElementsByClassName('item-actions')[0].getAttribute('data-cug');
  }
}
